<script lang="ts">
  import UserAvatarWrapper from '../../common/user/userAvatarWrapper.svelte';

  type PostPreviewData = {
    _id: string;
    creator: Pick<IUser<string>, '_id' | 'userName'> & { profileImage?: string };
    imageUrl: string;
  };

  export let post: PostPreviewData;
</script>

<div class="flex flex-col rounded-[16px] outline outline-1 outline-blueish-grey-200 pt-4 w-full h-full">
  <!-- Owner header  -->
  <div class="flex flex-col w-full gap-4">
    <div class="flex items-center gap-2 w-full px-4">
      <UserAvatarWrapper cls={'w-8 h-8'} profileImage={post.creator?.profileImage} />

      <span class="font-medium text-[#55697E]">{post.creator?.userName || 'Deleted'}</span>
    </div>

    <img class=" object-cover" src={post.imageUrl} alt="Post Preview" />
  </div>
</div>
